import React from "react";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";

// redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  pageNotFoundText: {
    textAlign: "center",
    paddingTop: "20vh",
  },
}));

function blog() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Page Not Found | Content Generator`}
        description={`Sorry, we couldn't find the page you're looking for. Return to Content Generator's homepage to access our social media marketing tools, post creator, and content generation features.`}
        url={`https://contentgenerator.io/404`}
      />
      <div className={classes.pageNotFoundText}>
        <Typography variant="h1">Page Not Found</Typography>
        <Typography>Sorry, the page you tried cannot be found.</Typography>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(blog);
